import { render, staticRenderFns } from "./FrameWork.vue?vue&type=template&id=dc725f1a&"
import script from "./FrameWork.vue?vue&type=script&lang=ts&"
export * from "./FrameWork.vue?vue&type=script&lang=ts&"
import style0 from "./FrameWork.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports